import {
  AccessTimeOutlined,
  PersonOutline,
  UpdateOutlined,
  MapOutlined,
  HistoryOutlined,
  PinDropOutlined,
  Description,
  Code,
  ApartmentOutlined,
  PublicOutlined,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useMunicipalityDetailContext } from "contexts/LocationContexts/MunicipalityDetailContext";
import React from "react";
import { localizeDateTimeMed } from "utils/dateFormats";
import ReactHtmlParser from "html-react-parser";

const MunicipalityBasicDetails = () => {
  const { municipalityDetail, loadingDetail } = useMunicipalityDetailContext();

  return !loadingDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <InformationTile
                  title="Municipality Name"
                  icon={() => <ApartmentOutlined color="primary" />}
                  subtitle={municipalityDetail?.name || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  title="Municipality Code"
                  icon={() => <Code color="primary" />}
                  subtitle={municipalityDetail?.code || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  title="Region"
                  icon={() => <PublicOutlined color="primary" />}
                  subtitle={municipalityDetail?.region?.name || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  title="District"
                  icon={() => <MapOutlined color="primary" />}
                  subtitle={municipalityDetail?.district?.name || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <PinDropOutlined color="primary" />}
                  title="Coordinates"
                  subtitle={
                    <Box>
                      {municipalityDetail?.coordinates
                        ? `${municipalityDetail?.coordinates?.lat}, ${municipalityDetail?.coordinates.long}`
                        : "No coordinates available"}
                    </Box>
                  }
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  title="Added By"
                  icon={() => <PersonOutline color="primary" />}
                  subtitle={municipalityDetail?.addedUser?.name || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccessTimeOutlined color="primary" />}
                  title="Created At"
                  subtitle={localizeDateTimeMed(municipalityDetail?.createdAt)}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <UpdateOutlined color="primary" />}
                  title="Updated At"
                  subtitle={localizeDateTimeMed(municipalityDetail?.updatedAt)}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <HistoryOutlined color="primary" />}
                  title="Status"
                >
                  <div
                    className={`uppercase ${
                      municipalityDetail?.status === "Active"
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    {municipalityDetail?.status}
                  </div>
                </InformationTile>
              </Grid>

              {municipalityDetail?.description && (
                <Grid item md={12}>
                  <InformationTile
                    icon={() => <Description color="primary" />}
                    title="Description"
                    subtitle={ReactHtmlParser(municipalityDetail?.description)}
                  />
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default MunicipalityBasicDetails;
